module.exports = __webpack_public_path__ + "img/case-viking.f1fadef7.png";